import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue } from "@utils/lodash";
//import { adminGetUsers } from '@services/users.service';
import { NavLink } from "react-router-dom";
//import moment from 'moment';
import {
  adminCreateCheckpoint,
  adminDeleteSpecificCheckpoint,
} from "@services/checkpoint.service";
import { useNavigate } from "react-router-dom";
import FilterForm from "@components/common/AddFilter/FilterForm";
import NavigationBar from "@components/NotificationBarCheckpoint/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import {
  adminGetcheckpointListManagementStateCategoryList,
  adminGetcheckpointListManagementStateLegislationList,
  adminGetcheckpointListManagementStateLegislationRuleList,
  adminGetCountriesListManagement,
  adminGetListManagementGroupCode,
  adminGetStatesListManagement,
} from "@services/list-management.service";
import Notfound from "@components/Not-Found";
import { adminBulkUpdateStatus } from "@services/users.service";
import Loader from "@components/common/Loader";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import "@pages/Task/MyTask/index.scss";
import FooterWrapper from "@components/common/FooterWrapper";
import { getSpecificCategoryLawById } from "@_common/global-apis";
interface ICheckpointActiveProps {}

const MyTask: React.FunctionComponent<ICheckpointActiveProps> = (
  props: any
) => {
  let navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    getPEComplianceList();
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getSmartFilterList();
      getEventDropdowns();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getSmartFilterList();
      getEventDropdowns();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      setRequest({
        country_id: getValue(params, `country_id`, ""),
        state_id: getValue(params, `state_id`, ""),
        category_of_law_id: getValue(params, `category_of_law_id`, ""),
        legislation_id: getValue(params, `legislation_id`, ""),
        legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
        event_id: getValue(params, `event_id`, ""),
        sub_event_id: getValue(params, `sub_event_id`, ""),
      });
      if (getValue(params, `country_id`, "")) {
        setFilterVisibility(true);
        getStatesList(getValue(params, `country_id`, ""));
      }
      if (getValue(params, `state_id`, "")) {
        getAlreadyAttachedData(getValue(params, `state_id`, ""));
        getLegislationList(getValue(params, `state_id`, ""));
      }
      if (getValue(params, `legislation_id`, "")) {
        getLegislationRuleList(getValue(params, `legislation_id`, ""));
      }
      if (getValue(params, `smart_filter_tags`, "")) {
        getSmartFilterList();
        // getLegislationRuleList(getValue(params, `legislation_id`, ""));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [licenseIDs, setLicenseIDs] = useState([]);
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      status: "active",
      sort_by: params.sort_by,
      country_id: getValue(params, `country_id`, ""),
      state_id: getValue(params, `state_id`, ""),
      category_of_law_id: await getSpecificCategoryLawById(
        getValue(params, `category_of_law_id`, "")
      ),
      legislation_id: getValue(params, `legislation_id`, ""),
      legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
      event_id: getValue(params, `event_id`, ""),
      sub_event_id: getValue(params, `sub_event_id`, ""),
      smart_filter_tags: selectedIDs,
      compliance_type_id: getValue(params, `compliance_type_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await adminCreateCheckpoint(payload);
      // let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.checkpoints`, []).map((item: object) => ({
            ...item,
            category_of_lawName: getValue(item, `category_of_law.text`, ""),
            compliance_typeName: getValue(item, `compliance_type.text`, ""),
            frequencyName: getValue(item, `frequency.text`, ""),
            compliance_activity: getValue(item, `compliance_activity`, ""),
            legislationName: getValue(item, `legislation.legislation_name`, ""),
            legislation_ruleName: getValue(
              item,
              `legislation_rule.rule_name`,
              ""
            ),
          }))
        );
        let licenseIDs = getValue(resp, `data.checkpoints`, []).filter(
          (item: object) =>
            getValue(item, `compliance_type.text`, "") === "License"
        );
        setLicenseIDs(
          getValue(licenseIDs, `length`, 0) > 0
            ? licenseIDs.map((item: any) => item.id)
            : []
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  // const handleDeleteFun = (id: string, value: string) => {
  // 	setDeleteValue(value);
  // 	setDeleteId(id);
  // 	handleDelete();
  // };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificCheckpoint(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  // const handleChangeSortBy = (value: string) => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());
  // 	params.sort_by = value;
  // 	props.history.push({
  // 		pathname: window.location.pathname,
  // 		query: params,
  // 	});
  // };

  // const handleChangeStatus = (value: string) => {
  // 	const urlSearchParams = new URLSearchParams(window.location.search);
  // 	const params = Object.fromEntries(urlSearchParams.entries());
  // 	params.status = value;
  // 	props.history.push({
  // 		pathname: window.location.pathname,
  // 		query: params,
  // 	});
  // };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const rowClick = (obj: object) => {
    // console.log(getValue(obj,`original`,''))
    // navigate(`/support/detail/${getValue(obj,`original.id`,'')}`)
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: {
          //   background:  'red',
          //   color: 'black'
        },
      };
    }
    return {};
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Checkpoint ID",
        accessor: "checkpoint_id",
        width: 250,
        Cell: ({ row }: any) => {
          return <NavLink to={`#`}>{row.values.checkpoint_id}</NavLink>;
        },
      },
      // {
      // 	Header: "Category of Law",
      // 	accessor: "category_of_lawName",
      // 	width: 250,
      // },
      {
        Header: "Compliance Type",
        accessor: "compliance_typeName",
        width: 250,
      },
      {
        Header: "Legislation",
        accessor: "legislationName",
        width: 250,
      },
      {
        Header: "Rule",
        accessor: "legislation_ruleName",
        width: 250,
      },
      {
        Header: "Activity",
        accessor: "compliance_activity",
        width: 250,
      },
      // {
      // 	Header: "Reference",
      // 	accessor: "reference",
      // 	width: 250,
      // },
      {
        Header: "Frequency",
        accessor: "frequencyName",
        width: 250,
      },

      // {
      // 	Header: "Action",
      // 	width: 250,
      // 	Cell: ({ row }: any) => {
      // 		return (
      // 			<>
      // 				<Button
      // 					color="primary"
      // 					onClick={() => handleEdit(row.original.id)}
      // 				>
      // 					Edit
      // 				</Button>
      // 				&nbsp;&nbsp;&nbsp;
      // 				<Button
      // 					color="danger"
      // 					onClick={() =>
      // 						handleDeleteFun(row.original.id, row.values.checkpoint_id)
      // 					}
      // 				>
      // 					Delete
      // 				</Button>
      // 			</>
      // 		);
      // 	},
      // },
    ],
    []
  );

  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */
  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
    event_id: "",
    sub_event_id: "",
  });
  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);

  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [legislationList, setLegislationList] = useState([]);
  const [ruleList, setRuleList] = useState([]);
  const [smartFilterList, setSmartFilterList] = useState([]);
  const [selectedSmartFilterIds, setSelectedSmartFilterIds] = useState<any>([]);
  const handleChangeSelectMulti = (e: any) => {
    setSelectedSmartFilterIds(e);
  };
  const [eventList, setEventsList] = useState([]);
  const [subEventList, setsub_eventsList] = useState([]);

  const getEventDropdowns = async () => {
    try {
      let sub_events = await adminGetListManagementGroupCode("sub-events");
      let events = await adminGetListManagementGroupCode("events");
      if (sub_events) {
        let list =
          getValue(sub_events, `data.listItems.length`, 0) > 0
            ? getValue(
                sub_events,
                `data.listItems`,
                []
              ).filter((item: object) => getValue(item, `is_active`, false))
            : [];
        setsub_eventsList(
          list.map((item: object) => ({
            id: getValue(item, `id`, ""),
            is_active: getValue(item, `is_active`, ""),
            text: getValue(item, `text`, ""),
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          }))
        );
      }
      if (events) {
        let list =
          getValue(events, `data.listItems.length`, 0) > 0
            ? getValue(events, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, false)
              )
            : [];
        setEventsList(
          list.map((item: object) => ({
            id: getValue(item, `id`, ""),
            is_active: getValue(item, `is_active`, ""),
            text: getValue(item, `text`, ""),
            value: getValue(item, `text`, ""),
            label: getValue(item, `text`, ""),
          }))
        );
      }
    } catch (error) {}
  };

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    reset1();
  };
  const reset1 = () => {
    setRequest({
      ...request,
      // country_id: "",
      state_id: "",
      category_of_law_id: "",
      legislation_id: "",
      legislation_rule_id: "",
    });
    setSelectedSmartFilterIds([]);
  };

  const getSmartFilterList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    try {
      let resp = await adminGetListManagementGroupCode("smart-filter");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setSmartFilterList(obj);
        if (getValue(selectedIDs, `length`, 0) > 0) {
          let arr: [] | any = [];
          selectedIDs.map((item: object) => {
            let filtered = obj.filter((ob: any) => ob.id == item);
            if (getValue(filtered, `length`, 0) > 0) {
              arr.push(filtered[0]);
            }
          });
          setSelectedSmartFilterIds(arr);
        }
      } else {
      }
    } catch (error) {}
  };

  const [peComplianceList, setPeComplianceList] = useState([]);
  const getPEComplianceList = async () => {
    try {
      let resp = await adminGetListManagementGroupCode("compliance-type");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
                getValue(item, `is_active`, "")
              )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setPeComplianceList(obj);
      } else {
      }
    } catch (error) {}
  };

  const getCountriesList = async () => {
    try {
      let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          }))
        );
      } else {
      }
    } catch (error) {}
  };

  const getStatesList = async (countryId: number) => {
    if (countryId) {
      try {
        let resp = await adminGetStatesListManagement(countryId);
        if (resp) {
          setStates(
            getValue(resp, `data.states`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `name`, ""),
              label: getValue(item, `name`, ""),
            }))
          );
        } else {
        }
      } catch (error) {}
    }
  };

  const getAlreadyAttachedData = async (state_id: string) => {
    if (state_id) {
      try {
        let resp = await adminGetcheckpointListManagementStateCategoryList(
          state_id
        );
        if (resp) {
          setCategoryOfLawList(
            getValue(resp, `data.stateCategoryOfLaw`, []).map(
              (item: object) => ({
                // ...item,
                id: getValue(item, `category_of_law.id`, ""),
                value: getValue(item, `category_of_law.text`, ""),
                label: getValue(item, `category_of_law.text`, ""),
              })
            )
          );
        } else {
        }
      } catch (error) {}
    }
  };

  const getLegislationList = async (stateId: string) => {
    if (stateId) {
      try {
        let resp = await adminGetcheckpointListManagementStateLegislationList(
          stateId
        );
        if (resp) {
          setLegislationList(
            getValue(resp, `data.legislations`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `legislation_name`, ""),
              label: getValue(item, `legislation_name`, ""),
            }))
          );
        } else {
        }
      } catch (error) {}
    }
  };
  const getLegislationRuleList = async (legislation_id: string) => {
    if (legislation_id) {
      try {
        let resp = await adminGetcheckpointListManagementStateLegislationRuleList(
          legislation_id
        );
        if (resp) {
          setRuleList(
            getValue(resp, `data.legislationRules`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `rule_name`, ""),
              label: getValue(item, `rule_name`, ""),
            }))
          );
        } else {
        }
      } catch (error) {}
    }
  };

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      setRequest({
        ...request,
        state_id: getValue(e, `id`, "") ? e.id : "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
      getAlreadyAttachedData(e.id);
      getLegislationList(e.id);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
    }
    if (type === "category_of_law_id") {
      setRequest({
        ...request,
        category_of_law_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "legislation_id") {
      setRequest({
        ...request,
        legislation_id: getValue(e, `id`, "") ? e.id : "",
        legislation_rule_id: "",
      });
      getLegislationRuleList(e.id);
    }

    if (type === "legislation_rule_id") {
      setRequest({
        ...request,
        legislation_rule_id: getValue(e, `id`, "") ? e.id : "",
      });
    }

    if (type === "event_id") {
      setRequest({
        ...request,
        event_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "sub_event_id") {
      setRequest({
        ...request,
        sub_event_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };

  const handleSubmitSmartFilter = () => {
    let selectedSmartFilterIdsPayload = JSON.parse(
      JSON.stringify(selectedSmartFilterIds)
    );
    if (
      getValue(request, `country_id`, "")
      // getValue(request, `state_id`, "")
      // && getValue(request, `category_of_law_id`, "") &&
      // getValue(request, `legislation_id`, "") &&
      // getValue(request, `legislation_rule_id`, "")
    ) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload: any = {
        ...params,
        page_no: params.page_no,
        country_id: getValue(request, `country_id`, ""),
        state_id: getValue(request, `state_id`, ""),
        category_of_law_id: getValue(request, `category_of_law_id`, ""),
        legislation_id: getValue(request, `legislation_id`, ""),
        legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
        search_text: getValue(params, `search_text`, ""),
        limit: getValue(params, `limit`, ""),
        event_id: getValue(request, `event_id`, ""),
        sub_event_id: getValue(request, `sub_event_id`, ""),
        smart_filter_tags:
          selectedSmartFilterIdsPayload.length > 0
            ? selectedSmartFilterIdsPayload.map((item: object) =>
                getValue(item, `id`, "")
              )
            : [],
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      toast.error("All fields are mandatory");
    }
  };

  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, "")
    );
  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, "")
    );
  let cat_ID =
    getValue(categoryOfLawList, `length`, 0) > 0 &&
    categoryOfLawList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `category_of_law_id`, "")
    );
  let leg_ID =
    getValue(legislationList, `length`, 0) > 0 &&
    legislationList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_id`, "")
    );
  let rule_ID =
    getValue(ruleList, `length`, 0) > 0 &&
    ruleList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_rule_id`, "")
    );

  let event_ID =
    getValue(eventList, `length`, 0) > 0 &&
    eventList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `event_id`, "")
    );

  let subevent_ID =
    getValue(subEventList, `length`, 0) > 0 &&
    subEventList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `sub_event_id`, "")
    );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await adminBulkUpdateStatus({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) {}
  };
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };

  /* -------------------------------------------------------------------------- */
  /*                              Navigation Routes                             */
  /* -------------------------------------------------------------------------- */

  const handleNavigate = (route: string) => {
    if (route === "release-to-vendor") {
      let payload: any = {
        checkpoint_id: selectedIDs,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`/checkpoint/${route}?${queryRequest}`);
    }
    if (route === "assign-to-PE") {
      let payload: any = {
        checkpoint_id: selectedIDs,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`/checkpoint/${route}?${queryRequest}`);
    }
    if (route === "add-to-tracker") {
      let payload: any = {
        checkpoint_id: selectedIDs,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`/checkpoint/${route}?${queryRequest}`);
    }
  };
  const [permissionLoading, setPermissionLoading] = React.useState(true);
  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };
  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "repository_checkpoint_company_master"
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 && (
            <div>
              <NavigationBar
                selectedIDs={selectedIDs}
                isUpdateTaskVisible={true}
                showUpdatePopup={setShowUpdatePopup}
              />
              {/* complete task popup */}
              <div
                className={`compelte-task-wrapper ${
                  showUpdatePopup ? "compelte-task-wrapper--active" : ""
                }`}
              >
                <div className="compelte-task-wrapper__header d-flex align-items-center justify-content-between">
                  <h6 className="compelte-task-wrapper__title">
                    Complete Task
                  </h6>
                  <img
                    src="/images/close-white.svg"
                    className="img-fluid navigation-bar-wrapper__close-btn"
                    onClick={() => {
                      setShowUpdatePopup(false);
                    }}
                  />
                </div>
                <div className="compelte-task-wrapper__body d-flex">
                  <div className="compelte-task-wrapper__completion flex-2">
                    <div className="compelte-task-wrapper__common-header">
                      <h5 className="compelte-task-wrapper__common-title">
                        Task Completion
                      </h5>
                    </div>
                    <div className="compelte-task-wrapper__form">
                      <div className="compelte-task-wrapper__form-group">
                        <label className="compelte-task-wrapper__label">
                          Complition Date
                        </label>
                        <div className="compelte-task-wrapper__status compelte-task-wrapper__status--width d-flex align-items-center justify-content-between cursor-pointer">
                          <p>02-May-2021</p>
                          <img src="/images/calander.svg" />
                        </div>
                        <div className="d-flex mt-3 gap position-relative">
                          <label>
                            <input
                              type="checkbox"
                              className="default-checkbox"
                            />
                            <div className="custom-checkbox">
                              <img
                                src="/images/uploaded-details/tick.svg"
                                className="upload-tick img-fluid"
                              />
                            </div>
                          </label>
                          <p>Event did not occur</p>
                        </div>
                      </div>
                      <div className="compelte-task-wrapper__form-group">
                        <label className="compelte-task-wrapper__label">
                          Remarks
                        </label>
                        <textarea
                          placeholder="Remarks"
                          className="w-100 compelte-task-wrapper__text-area"
                          rows={5}
                        ></textarea>
                      </div>
                      <div className="compelte-task-wrapper__form-group">
                        <label className="compelte-task-wrapper__label">
                          Reason for Non-Compliance
                        </label>
                        <textarea
                          placeholder="Enter Reason for Non-Compliance"
                          className="w-100 compelte-task-wrapper__text-area"
                          rows={5}
                        ></textarea>
                      </div>
                      <div className="compelte-task-wrapper__form-group">
                        <label className="compelte-task-wrapper__label">
                          Upload Proof Of Compliance
                          <input type="file" className="d-none" />
                          <div className="custom-file mt-2 d-flex">
                            <span className="custom-file--attach">
                              Attach files
                            </span>
                          </div>
                        </label>
                        <div className="compelte-task-wrapper__uploaded-files">
                          <ul>
                            <li className="compelte-task-wrapper__uploaded d-flex align-items-center justify-content-between">
                              <span>Billing_Date.pdf</span>
                              <img src="/images/close-black.svg" />
                            </li>
                            <li className="compelte-task-wrapper__uploaded d-flex align-items-center justify-content-between">
                              <span>Billing_Date.pdf</span>
                              <img src="/images/close-black.svg" />
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="compelte-task-wrapper__cta d-flex align-items-center gap">
                      <button className="ascent-button ascent-button--primary">
                        Cancel
                      </button>
                      <button className="ascent-button ascent-button--secondary">
                        Mark Complied
                      </button>
                    </div>
                  </div>
                  <div className="compelte-task-wrapper__response flex-1">
                    <div className="compelte-task-wrapper__common-header">
                      <h5 className="compelte-task-wrapper__common-title">
                        Task Responses
                      </h5>
                    </div>
                    <div className="compelte-task-wrapper__form">
                      <div className="compelte-task-wrapper__form-group">
                        <label className="compelte-task-wrapper__label">
                          Compliance Status
                        </label>
                        <div className="compelte-task-wrapper__status">
                          Non Complied
                        </div>
                      </div>
                      <div className="compelte-task-wrapper__form-group">
                        <label className="compelte-task-wrapper__label">
                          Remarks
                        </label>
                        <p>No remark found</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="dashboard-wrapper__header">
            <h4 className="dashbaord-wrapper__header-title">Master</h4>
          </div>

          <div className="admin-wrapper position-relative">
            <div className="admin-wrapper position-relative">
              <SearchHeader
                route={"/support/details"}
                searchInput={search_text}
                showSearchTextbox={showSearchTextbox}
                toggleSearch={toggleSearch}
                toggleSearchClose={toggleSearchClose}
                handleChangeSearch={handleChangeSearch}
                isBulkUploadVisible={false}
                smartFilter={true}
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                add={"false"}
                isFilterVisible={isFilterVisible}
                filterCompliance
                peComplianceList={peComplianceList}
                handleChangeStatus={handleChangeStatus}
              />
            </div>
            {isFilterVisible && (
              <FilterForm
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                countryList={countryList}
                states={states}
                categoryOfLawList={categoryOfLawList}
                legislationList={legislationList}
                ruleList={ruleList}
                handleChangeSelect={handleChangeSelect}
                additionalFilter={true}
                country_ID={country_ID}
                state_ID={state_ID}
                cat_ID={cat_ID}
                leg_ID={leg_ID}
                rule_ID={rule_ID}
                reset={reset}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                smartFilterList={smartFilterList}
                handleChangeSelectMulti={handleChangeSelectMulti}
                selectedSmartFilterIds={selectedSmartFilterIds}
                events={true}
                event_ID={event_ID}
                subevent_ID={subevent_ID}
                eventList={eventList}
                subEventList={subEventList}
              />
            )}
            {/* <AddFilter
			isFilterVisible={isFilterVisible}
			isFilterHeadingVisible={true}
			isFilterSubHeadingVisible={true}
			isBulkUploadVisible={true}
			addButtonLink={'/checkpoint/active-detail'}
			setFilterFormVisibility={() => {
			  setFilterVisibility(!isFilterVisible);
			}}
		  />
		   */}
            {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : list.length > 0 ? (
              <ScrollableDataTable
                columns={columns}
                data={list}
                getTableState={getTableState}
                rowClick={rowClick}
                check={check}
                selectedIDs={selectedIDs}
                getTrProps={getTrProps}
              />
            ) : (
              <>
                {Object.keys(params).length !== 0 ? (
                  <>
                    <Notfound />
                  </>
                ) : (
                  <Notfound />
                )}
              </>
            )}
          </div>
          <FooterWrapper
            list={list}
            totalCount={totalCount}
            limit={limit}
            page_no={page_no}
            handleChangePagination={handleChangePagination}
            handleChangeLimit={handleChangeLimit}
          />

          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
        </>
      )}
    </DashboardLayout>
  );
};
export default MyTask;
